import React from "react"
import { ReportSection } from "~/api/communications"
import QuarterlyReportLayout from "./QuarterlyReportLayout"
import PdfPageWrapper from "./PdfPageWrapper"
import { useCommunicationContext } from "./CommunicationContext"
import { useQuarterlyReportContext } from "./useQuarterlyReportContext"
import { usePdfView } from "./usePdfView"
import { PortfolioCompanyLogos } from "@/editor/PortfolioCompanyLogosTool"

const LogosCompanyCounts: React.FC = () => {
  const { communicationId } = useCommunicationContext()
  const { reportId, report, isLoading, error, mock } =
    useQuarterlyReportContext()
  const { showPdfView, pdfLoading, pdfUrl, togglePdfView, loadPdfView } =
    usePdfView({
      reportId,
      sectionName: ReportSection.LOGOS_COMPANY_COUNTS,
      editorContent: { section: "logos_company_counts", reportId },
      mock,
    })

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading Logos / Company Counts...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Failed to load report: {error.message}
      </div>
    )
  }

  if (!report) {
    return (
      <div className="alert alert-warning" role="alert">
        Report not found
      </div>
    )
  }

  const portfolioCompanies =
    report.section_content?.editor_data_content?.portfolio_companies

  return (
    <QuarterlyReportLayout
      title="Logos / Company Counts"
      subtitle={`Logos / Company Counts for ${report.household_name}`}
      showEditorActions={true}
      reportId={reportId}
      showPdfView={showPdfView}
      pdfLoading={pdfLoading}
      pdfUrl={pdfUrl}
      onTogglePdfView={togglePdfView}
      breadcrumbProps={{
        householdName: report.household_name,
        householdPath: `/manage/communications/${communicationId}/quarterly_reports/${reportId}`,
        sectionName: ReportSection.LOGOS_COMPANY_COUNTS,
      }}
    >
      <PdfPageWrapper
        sectionTitle="Logos / Company Counts"
        onPdfViewClick={loadPdfView}
      >
        <h3 className="pdf-page-section-title">Portfolio Companies</h3>
        {portfolioCompanies && portfolioCompanies.length > 0 ? (
          <PortfolioCompanyLogos portfolioCompanies={portfolioCompanies} />
        ) : (
          <div className="editorjs-empty-tool-table">
            No portfolio companies available
          </div>
        )}
      </PdfPageWrapper>
    </QuarterlyReportLayout>
  )
}

export default LogosCompanyCounts
